import { createGetEndpoint } from '@sonar-software/sonar-http';
import { RecommendedActionTemplate } from '@types';

export type GetRecommendedActionTemplatesResponse = Array<RecommendedActionTemplate>;

export const getRecommendedActionTemplates =
	createGetEndpoint<void, GetRecommendedActionTemplatesResponse>('/api/v3/recommended-actions/templates/');
